import { render, staticRenderFns } from "./DappDetailedStatsChart.vue?vue&type=template&id=4a7f1a53&scoped=true"
import script from "./DappDetailedStatsChart.vue?vue&type=script&lang=ts"
export * from "./DappDetailedStatsChart.vue?vue&type=script&lang=ts"
import style0 from "./DappDetailedStatsChart.vue?vue&type=style&index=0&id=4a7f1a53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7f1a53",
  null
  
)

export default component.exports